import {
  GET_CLIENTES_REQUEST,
  GET_CLIENTES_SUCCESS,
  GET_CLIENTES_FAILURE,
  RESET_CLIENTES,
} from '../../constants/clientes/clientes.constants';

export const getClientesAction = (page = 1, start = 0, limit = 99999, sede,
  archivado, tipoListado, busqueda = null, clientesSeleccionados = []) => ({
  type: GET_CLIENTES_REQUEST,
  payload: {
    page, start, limit, sede, archivado, tipoListado, busqueda, clientesSeleccionados,
  },
});

export const getClientesSuccessAction = (datos, total, page, start, limit) => ({
  type: GET_CLIENTES_SUCCESS,
  payload: {
    datos, total, page, start, limit,
  },
});

export const getClientesFailureAction = error => ({
  type: GET_CLIENTES_FAILURE,
  payload: error,
});

export const resetClientes = () => ({
  type: RESET_CLIENTES,
});
